import { graphql } from '~/lib/graphql'

export const InventorySeats = graphql(`
  fragment InventorySeats on ReservableTime {
    seats {
      seatId
      type
      seatTypeLabel
      attributes
      smokingAllowed
      seatTypeDescription
      description
      bookingType
      capacity
      childUse
      image {
        url
        name
        category
      }
      charge {
        __typename
        ... on SeatChargePerTable {
          price
        }
        ... on SeatChargePerPerson {
          price
        }
      }
      ...SeatForLabel
    }
  }
`)
